module.exports = __webpack_public_path__ + "static/media/image-polaroid.b0b63bc8.svg";